(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2341],{

/***/ 72013:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/account/login",
      function () {
        return __webpack_require__(68170);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12601);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20368);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77480);
/* harmony import */ var hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72507);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53625);
/* harmony import */ var ui_components_Page__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87150);
/* harmony import */ var ui_forms_AuthenticateForm__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8165);
/* harmony import */ var ui_components_PageHead__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9294);
/* harmony import */ var ui_pages_LayoutAccountPage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88752);
/* harmony import */ var ui_forms_OTPForm__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83688);















var Login = function() {
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)();
    var guest = (0,hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__/* .useAuth */ .aC)().guest;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var localizeUrlPath = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_4__/* .useSiteConfig */ .N)().localizeUrlPath;
    var authAction = router.query.action;
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (!guest) router.replace(localizeUrlPath("/account"));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    if (!guest) return null;
    var ref;
    var title = (ref = t("pageTitleFragmentLogin")) !== null && ref !== void 0 ? ref : "".concat(t("account"), " ").concat(authAction === ui_forms_AuthenticateForm__WEBPACK_IMPORTED_MODULE_9__/* .AuthAction.register */ .g.register ? t("register") : t("login"));
    var ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_PageHead__WEBPACK_IMPORTED_MODULE_10__/* .PageHead */ .y, {
                title: t("pageTitle", {
                    title: title
                }),
                description: (ref1 = t("pageDescriptionLogin")) !== null && ref1 !== void 0 ? ref1 : ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_Page__WEBPACK_IMPORTED_MODULE_8__/* .Page */ .T, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_pages_LayoutAccountPage__WEBPACK_IMPORTED_MODULE_11__/* .LayoutAccountPage */ .x, {
                    title: t("myAccount"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CreateAccountForm, {})
                })
            })
        ]
    });
};
var CreateAccountForm = function() {
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var isOTPAuthEnabled = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_7__/* .useFeature */ .S)("OTP_LOGIN");
    var ref = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_4__/* .useSiteConfig */ .N)(), localizeUrlPath = ref.localizeUrlPath, _forms = ref.forms, quickRegistrationForm = _forms.quickRegistration;
    var showQuickRegistration = Boolean(router.asPath.includes("showQuickRegister") && (quickRegistrationForm === null || quickRegistrationForm === void 0 ? void 0 : quickRegistrationForm.length));
    var authAction = router.query.action;
    var handleSignInSuccess = function() {
        // Redirect the user to back where they came from or to account
        var _query = router.query, from = _query.from, action = _query.action, language = _query.language, country = _query.country, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_query, [
            "from",
            "action",
            "language",
            "country"
        ]);
        window.sessionStorage.setItem("new-user", (authAction === ui_forms_AuthenticateForm__WEBPACK_IMPORTED_MODULE_9__/* .AuthAction.register */ .g.register).toString());
        router.push({
            pathname: localizeUrlPath(from || "account"),
            query: showQuickRegistration ? "" : rest
        });
    };
    var authenticateFormProps = {
        from: router.query.from,
        onSuccess: handleSignInSuccess,
        resetOnOverlay: true,
        showQuickRegistration: showQuickRegistration
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W20, {
        size: showQuickRegistration ? "xs" : "sm",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Stack */ .Kqy, {
            children: [
                showQuickRegistration && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Heading */ .X6q, {
                    asChild: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: t("quickAccountRegistrationHeadline")
                    })
                }),
                isOTPAuthEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_forms_OTPForm__WEBPACK_IMPORTED_MODULE_12__/* .OTPAuthenticateForm */ .Q, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                    action: authAction
                }, authenticateFormProps)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_forms_AuthenticateForm__WEBPACK_IMPORTED_MODULE_9__/* .AuthenticateForm */ .c, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                    action: authAction
                }, authenticateFormProps))
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Login);


/***/ }),

/***/ 37404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ Breadcrumb; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ../node_modules/string-strip-html/dist/string-strip-html.cjs.js
var string_strip_html_cjs = __webpack_require__(50967);
// EXTERNAL MODULE: ./utils/removeHyphens.ts
var removeHyphens = __webpack_require__(47802);
// EXTERNAL MODULE: ./utils/capitalize.ts
var capitalize = __webpack_require__(59308);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(39772);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./ui/elements/InjectedScript.tsx
var InjectedScript = __webpack_require__(19735);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(25380);
// EXTERNAL MODULE: ./utils/isContentOnline.ts
var isContentOnline = __webpack_require__(89996);
// EXTERNAL MODULE: ./utils/breadcrumbRedirects.ts + 1 modules
var breadcrumbRedirects = __webpack_require__(5567);
;// CONCATENATED MODULE: ./hooks/useBreadcrumbUrlRedirects.ts








var isRedirectActive = function(redirect) {
    var availableFrom = redirect.availableFrom, availableTo = redirect.availableTo;
    var isAvailable = (0,isContentOnline/* isContentOnline */.e)({
        onlineFrom: availableFrom,
        onlineTo: availableTo
    }, {});
    if (!isAvailable || !redirect.url) return false;
    return true;
};
var useBreadcrumbUrlRedirects = function(links) {
    var client = (0,urql_es/* useClient */.m8)();
    var ref = (0,react.useState)(undefined), redirections = ref[0], setRedirections = ref[1];
    var fetchRedirections = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var breadcrumbPromises, results, updatedPaths, _tmp, _tmp1, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    breadcrumbPromises = (0,breadcrumbRedirects/* fetchBreadcrumbRedirectPromises */.VD)(client, links);
                    return [
                        4,
                        Promise.all(breadcrumbPromises)
                    ];
                case 1:
                    results = _state.sent();
                    updatedPaths = results.map(function(param, idx) {
                        var data = param.data;
                        return data && isRedirectActive(data.urlRedirectV2) ? {
                            label: links[idx + 1].label,
                            url: data.urlRedirectV2.url
                        } : (0,_object_spread/* default */.Z)({}, links[idx + 1]);
                    });
                    _tmp = {};
                    _tmp1 = {};
                    if (updatedPaths.length > 0) {
                        setRedirections([
                            (0,_object_spread/* default */.Z)(_tmp, links[0])
                        ].concat((0,_to_consumable_array/* default */.Z)(updatedPaths), [
                            (0,_object_spread/* default */.Z)(_tmp1, links[links.length - 1])
                        ]));
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        client,
        links
    ]);
    return {
        fetchRedirections: fetchRedirections,
        redirections: redirections
    };
};

// EXTERNAL MODULE: ./utils/locale.ts + 1 modules
var utils_locale = __webpack_require__(79302);
;// CONCATENATED MODULE: ./ui/components/Breadcrumb.tsx
















var Breadcrumb = function(param) {
    var path = param.path, isPdpFromPlp = param.isPdpFromPlp;
    var router = (0,next_router.useRouter)();
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), host = ref.host, locale = ref.locale, absoluteLinkBreadcrumb = ref.absoluteLinkBreadcrumb, isPNARegion = ref.staticFeatures.isPNARegion;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var protocol = constants/* isServer */.sk ? "https:" : window.location.protocol;
    var baseUrlLink = "".concat(protocol, "//").concat(host).concat((0,utils_locale/* getUrlFromLocale */.bH)(locale));
    var baseUrl = absoluteLinkBreadcrumb ? baseUrlLink : "";
    var pdpUrlRegex = /^[a-z]{2}\/[a-z]{2}\/pd\/.*\/\\d{6,}/;
    var isPdp = pdpUrlRegex.test(router.pathname);
    // Build links array
    var links = (0,react.useMemo)(function() {
        return path.filter(function(pathElement) {
            return pathElement.url !== "/puma";
        }).map(function(param) {
            var label = param.label, url = param.url;
            var displayLabel = isPdp ? (0,removeHyphens/* removeHyphens */.V)(label) : label === "home" ? t("home") : label;
            var fullUrl = "".concat(baseUrl, "/").concat(encodeURI(url.length && url[0] === "/" ? url.slice(1) : url));
            return {
                label: displayLabel,
                url: fullUrl
            };
        });
    }, [
        path,
        isPdp,
        t,
        host,
        locale
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var ref1 = useBreadcrumbUrlRedirects(links), redirections = ref1.redirections, fetchRedirections = ref1.fetchRedirections;
    (0,react.useEffect)(function() {
        if (isPNARegion && links.length > 0) {
            fetchRedirections();
        }
    }, [
        isPNARegion,
        links.length,
        fetchRedirections
    ]);
    var prevToLastLink = links[links.length - 2] || links[0];
    var showMobilePdpBreadcrumb = !(0,media/* getIsDesktop */.w)() && isPdpFromPlp;
    var removeTrailingSlash = function(url) {
        return url.endsWith("/") ? url.slice(0, -1) : url;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showMobilePdpBreadcrumb ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "flex items-center font-bold",
                onClick: function() {
                    return router.back();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-0.5 mr-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                            size: "sm",
                            name: "chevron-left"
                        })
                    }),
                    prevToLastLink.label
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Breadcrumb */.aGc, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* FITANALYTICS_IS_LOADED_INDICATOR */.S7), {
                path: redirections !== null && redirections !== void 0 ? redirections : links,
                className: "-ml-1.5"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InjectedScript/* InjectedScript */.D, {
                type: "application/ld+json",
                script: JSON.stringify({
                    "@context": "https://schema.org/",
                    "@type": "BreadcrumbList",
                    itemListElement: links.map(function(item, index) {
                        return {
                            "@type": "ListItem",
                            position: index + 1,
                            name: (0,capitalize/* capitalize */.k)((0,string_strip_html_cjs.stripHtml)(item.label).result),
                            item: item.url.startsWith("http") ? item.url : removeTrailingSlash("".concat(baseUrlLink).concat(item.url)),
                            logo: "https://".concat(host, "/assets/logo-puma-black.png")
                        };
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 88752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ LayoutAccountPage; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
;// CONCATENATED MODULE: ./ui/components/MyAccountHeader.tsx




var MyAccountHeader = function(param) {
    var title = param.title, subtitle = param.subtitle;
    var hideMyAccountSubtitle = (0,useFeature/* useFeature */.S)("HIDE_MY_ACCOUNT_SUBTITLE");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
        items: "start",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
            gap: "xs",
            items: "start",
            asChild: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                        className: "order-2",
                        size: {
                            _: "xl",
                            md: "3xl"
                        },
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: title
                        })
                    }),
                    subtitle && !hideMyAccountSubtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Heading */.X6q, {
                        className: "order-1",
                        size: {
                            _: "xs",
                            md: "base"
                        },
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: subtitle
                        })
                    }) : null
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./ui/components/Breadcrumb.tsx + 1 modules
var Breadcrumb = __webpack_require__(37404);
;// CONCATENATED MODULE: ./ui/pages/LayoutAccountPage.tsx





var LayoutAccountPage = function(param) {
    var title = param.title, subtitle = param.subtitle, breadcrumb = param.breadcrumb, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Container */.W20, {
        size: "lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
            gap: "sm",
            children: [
                breadcrumb ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* Breadcrumb */.a, {
                    path: breadcrumb
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Stack */.Kqy, {
                    gap: "xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MyAccountHeader, {
                            title: title,
                            subtitle: subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Stack */.Kqy, {
                            items: "center",
                            className: "pb-8",
                            children: children
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 5567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hH": function() { return /* binding */ createCategoryPageBreadcrumbLinks; },
  "A2": function() { return /* binding */ createProductBreadcrumbLinks; },
  "VD": function() { return /* binding */ fetchBreadcrumbRedirectPromises; }
});

// UNUSED EXPORTS: getLinksToCheck

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
;// CONCATENATED MODULE: ./gql/queries/urlRedirect.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query UrlRedirect($path: String!) {\n    urlRedirectV2(path: $path) {\n      availableFrom\n      availableTo\n      redirectType\n      url\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var URL_REDIRECT_QUERY = (0,urql_core/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./utils/constructCategoryPath.ts
var constructCategoryPath = __webpack_require__(97729);
;// CONCATENATED MODULE: ./utils/breadcrumbRedirects.ts



/**
 * Creates an array of breadcrumb links from a category
 * @param currentCategory - The category data
 * @returns Array of breadcrumb links
 */ var createCategoryPageBreadcrumbLinks = function(currentCategory) {
    var categoryPath = (0,constructCategoryPath/* constructCategoryPath */.h)(currentCategory);
    return [
        {
            label: "home",
            url: ""
        }
    ].concat((0,_to_consumable_array/* default */.Z)(categoryPath));
};
/**
 * Creates breadcrumb links specifically for product detail pages
 * @param params - Object containing necessary data for product breadcrumbs
 * @returns Array of raw breadcrumb links ready for display
 */ var createProductBreadcrumbLinks = function(param) {
    var categoryById = param.categoryById, productName = param.productName, productLink = param.productLink, _isCustomizing = param.isCustomizing, isCustomizing = _isCustomizing === void 0 ? false : _isCustomizing, _customizeUrl = param.customizeUrl, customizeUrl = _customizeUrl === void 0 ? "" : _customizeUrl, _customizeLabel = param.customizeLabel, customizeLabel = _customizeLabel === void 0 ? "customize" : _customizeLabel, _isPersonalizing = param.isPersonalizing, isPersonalizing = _isPersonalizing === void 0 ? false : _isPersonalizing, _personalizeLabel = param.personalizeLabel, personalizeLabel = _personalizeLabel === void 0 ? "personaliseBreadcrumb" : _personalizeLabel;
    var categoryLinks = createCategoryPageBreadcrumbLinks(categoryById);
    var links = (0,_to_consumable_array/* default */.Z)(categoryLinks);
    if (productName && productLink) {
        links.push({
            label: productName,
            url: productLink,
            isAbsoluteUrl: true
        });
    }
    if (isCustomizing && customizeUrl) {
        links.push({
            label: customizeLabel,
            url: customizeUrl
        });
    }
    if (isPersonalizing) {
        links.push({
            label: personalizeLabel,
            url: ""
        });
    }
    return links;
};
/**
 * Gets the links that need to be checked for redirects
 * @param links - The full breadcrumb links array
 * @returns Array of links to check for redirects
 */ var getLinksToCheck = function(links) {
    // Skip first and last elements as per useBreadcrumbUrlRedirects implementation
    return links.slice(1, -1);
};
/**
 * Fetches URL redirect queries for breadcrumb links
 * @param client - The URQL client
 * @param links - The links to check for redirects
 * @returns Promise with the results of the redirect queries
 */ var fetchBreadcrumbRedirectPromises = function(client, links) {
    var linksToCheck = getLinksToCheck(links);
    // Create URL redirect queries for each breadcrumb link
    return linksToCheck.map(function(param) {
        var url = param.url;
        return client.query(URL_REDIRECT_QUERY, {
            path: url.startsWith("/") ? url.slice(1) : url
        });
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9372,1489,9294,2042,6740,769,9774,2888,179], function() { return __webpack_exec__(72013); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);